import { useDispatch } from "react-redux";
import { useAppState } from "../../store/hooks";
import { AlertMessageType } from "../../types";
import { uiSelectors } from "./ui.selectors";
import { uiActions } from "./ui.slice";

export const useUiState = () => {
  const dispatch = useDispatch();
  // Create actions to be dispatched and state selections from selectors.
  const stateHook = useAppState({
    selectors: uiSelectors,
    actions: uiActions,
  });
  const setTimedAlertMessage = (
    data: AlertMessageType & { timer?: number },
  ) => {
    const { timer = 5000, ...alertData } = data;
    dispatch(uiActions.setAlertMessage(alertData));
    setTimeout(() => {
      dispatch(uiActions.setAlertMessage({ severity: undefined }));
    }, timer);
  };

  return { ...stateHook, setTimedAlertMessage };
};
